/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { Heading, Icon, Link } from 'bold-ui'
import { useFirebase } from 'hooks/firebase/useFirebase'

export function MChatAccessDocLink() {
  const { analytics } = useFirebase()

  return (
    <Link
      style={classes.acessDocContainer}
      href='https://mchatscreen.com/wp-content/uploads/2020/09/M-CHAT-R_F_Brazilian_Portuguese_v2.pdf'
      target='_blank'
      onClick={() => analytics.logEvent('click_abrir_consulta_de_seguimento')}
    >
      <Icon icon='openInNewTabOutline' size={1.25} />
      <Heading level={5} color='primary'>
        Acessar documento
      </Heading>
    </Link>
  )
}

const classes = {
  acessDocContainer: css`
    display: flex;
    align-items: center;
    gap: 0.25rem;
    margin-left: -0.5rem;
  `,
}
